import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';

@Directive({
  selector: '[appIndexedLink]',
})
export class IndexedLinkDirective implements OnInit, AfterViewInit {
  @Input() indexedLink: string[] | null = null;
  @Input() targetParams: {[key: string]: any} | null = null;
  @Input() targetUrl: string[] | null = null;

  constructor(
    private el: ElementRef,
    private router: Router,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.indexedLink) {
      if (this.el.nativeElement.hasAttribute('routerLink')) {
        this.renderer.setAttribute(
          this.el.nativeElement,
          'data-original-routerlink',
          JSON.stringify(this.el.nativeElement.getAttribute('routerLink')),
        );
      }

      if (this.el.nativeElement.hasAttribute('queryParams')) {
        this.renderer.setAttribute(
          this.el.nativeElement,
          'data-original-queryparams',
          JSON.stringify(this.el.nativeElement.getAttribute('queryParams')),
        );
      }

      if (this.el.nativeElement.hasAttribute('title')) {
        const originalTitle = this.el.nativeElement.getAttribute('title');
        this.renderer.setAttribute(this.el.nativeElement, 'data-original-title', originalTitle);
      }
    }
  }

  ngAfterViewInit() {
    if (this.indexedLink) {
      setTimeout(() => {
        const indexedUrl = this.routerLinkToString(this.indexedLink);
        this.renderer.setAttribute(this.el.nativeElement, 'href', indexedUrl);
      }, 0);
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.targetUrl || this.indexedLink) {
      event.preventDefault();
      event.stopPropagation();

      setTimeout(() => {
        const targetRoute = this.targetUrl || this.indexedLink;
        this.router.navigate(targetRoute, {
          queryParams: this.targetParams || {},
        });
      }, 5);
    }
  }

  private routerLinkToString(routerLink: string[]): string {
    if (!routerLink || routerLink.length === 0) {
      return '/';
    }
    const firstElement =
      routerLink[0] === '' ? '/' : routerLink[0].startsWith('/') ? routerLink[0] : `/${routerLink[0]}`;
    const restElements = routerLink.slice(1);

    return [firstElement, ...restElements].join('/').replace(/\/\/+/g, '/');
  }
}
